export interface WebSocketListener {
  onMessage(message: string): void
}

export class WebSocketManager {
    private socket: WebSocket|undefined
    private listeners: WebSocketListener[] = []
    constructor(
        private readonly port: number,
        private readonly autoReconnect: boolean = true,
        private readonly buffer: string[] = []
    ) { }

    addListener(listener: WebSocketListener) {
        this.listeners.push(listener)
    }

    stop() {

        if (this.socket) {
            this.socket.close()
            this.socket = undefined
        }
    }

    private createSocket(): void {
        if (!this.socket) {
            const protocol = window.location.protocol === "https:" ? "wss" : "ws"
            console.log("WAHT",window.location.protocol, protocol )
            const host = window.location.host
            const socket = new WebSocket(`${protocol}://${host}/websocket`)

            socket.onopen = ()=>{
                this.socket = socket

                if(this.buffer.length) {
                    this.buffer.forEach((message)=>{
                        socket.send(message)
                    })
                    this.buffer.length = 0
                }
            }

            socket.onerror = (x)=>{
                console.log("Socket errors",x)
                this.socket = undefined
            }

            socket.onmessage = (event)=>{
                this.listeners.forEach(l=>l.onMessage(event.data))
            }

            socket.onclose = (event)=>{
                console.log(`Connection closed. code=${event.code} reason=${event.reason}`,event)
                this.socket = undefined

                if (this.autoReconnect) {
                    setTimeout(()=>{
                        this.createSocket()
                    }, 3000)
                    console.log("Reconnecting websocket.")
                }
            }
        } else {
            console.log("Creating socket while still ongoing.")
        }
    }

    send(data: string): void {
        if(this.socket) {
            this.socket.send(data)
        } else {
            this.buffer.push(data)
        }
    }

    start() {
        this.createSocket()
    }
}